import React, {useCallback, useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {Query} from "@syncfusion/ej2-data";
import DropDownList from "../../../../DropDownList/DropDownList";
import {CheckBoxSelection, DropDownListComponent, Inject, MultiSelectComponent} from "@syncfusion/ej2-react-dropdowns";
import Input from "../../../../Input/Input";
import apiAxios from "../../../../../../../app/api/apiAxios";

const SectionSection = ({
                            isLoading,
                            //sectionValue,
                            parking,
                            buildingTypeValue,
                            //streetValue,
                           // buildingNumberValue,
                           // entranceValue,
                            //apartmentValue,
                            onSectionChange,
                            onBuildingTypeChange,
                            onBuildingChange,
                            onEntranceChange,
                            onApartmentChange,
                            onStreetChange,
                            onParkingChange,
                        }) => {
    //const [streetQuery, setStreetQuery] = useState(sectionValue !== null ? new Query().addParams("sectionId", sectionValue) : null);

    const  section_fields = { text: 'text', value: 'id' };
    const  street_fields = { text: 'text', value: 'id' };

    const  building_fields = { text: 'text', value: 'id' };
    const  entrance_fields = { text: 'text', value: 'id' };
    const  apartment_fields = { text: 'text', value: 'id' };

    const [sectionsData, setSectionsData] = useState([]);
    const [sectionsSelectedData, setSectionsSelectedData] = useState([]);
    const [streetsData, setStreetsData] = useState([]);
    const [streetsSelectedData, setStreetsSelectedData] = useState([]);

    const [buildingsData, setBuildingsData] = useState([]);
    const [buildingSelectedData, setBuildingSelectedData] = useState([]);
    const [entrancesData, setEntrancesData] = useState([]);
    const [entranceSelectedData, setEntranceSelectedData] = useState([]);
    const [apartmentsData, setApartmentsData] = useState([]);
    const [apartmentSelectedData, setApartmentSelectedData] = useState([]);

    const loadSections = async () => {

        // setIsLoading(true);
        const url = `${process.env.REACT_APP_BE_DOMAIN}/api/target/getSections`;

        try {
            const response = await apiAxios.get(url);

            if (response) {
                if (response.status === 200 && response.data) {


                    setSectionsData(response.data);
                }
            }

            // setIsLoading(false);
        } catch (e) {
            if (e && e.message) {
                //  setServerError(`${t(getServerErrorResourceName({
                //     model: 'subSectionSection',
                //     resultCode: ResultCode.ServerError
                //  }))} Message: (${e.message})`);
            }
            // setIsLoading(false);
        }

    };

    const loadStreets = async () => {

        if(!sectionsSelectedData || sectionsSelectedData.length !== 1) {
            setStreetsData([]);
            return
        }

        // setIsLoading(true);
        const url = `${process.env.REACT_APP_BE_DOMAIN}/api/target/getStreets?sectionId=` + sectionsSelectedData[0];

        try {
            const response = await apiAxios.get(url);

            if (response) {
                if (response.status === 200 && response.data) {


                    setStreetsData(response.data);
                }
            }

            // setIsLoading(false);
        } catch (e) {
            if (e && e.message) {
                //  setServerError(`${t(getServerErrorResourceName({
                //     model: 'subSectionSection',
                //     resultCode: ResultCode.ServerError
                //  }))} Message: (${e.message})`);
            }
            // setIsLoading(false);
        }

    };

    const loadBuildings = async () => {

        if(!streetsSelectedData || streetsSelectedData.length !== 1) {
            setBuildingsData([]);
            return
        }

        // setIsLoading(true);
        const url = `${process.env.REACT_APP_BE_DOMAIN}/api/target/getBuildings?streetId=` + streetsSelectedData[0];

        try {
            const response = await apiAxios.get(url);

            if (response) {
                if (response.status === 200 && response.data) {


                    setBuildingsData(response.data);
                }
            }

            // setIsLoading(false);
        } catch (e) {
            if (e && e.message) {
                //  setServerError(`${t(getServerErrorResourceName({
                //     model: 'subSectionSection',
                //     resultCode: ResultCode.ServerError
                //  }))} Message: (${e.message})`);
            }
            // setIsLoading(false);
        }

    };

    const loadEntrances = async () => {

        if(!buildingSelectedData || buildingSelectedData.length !== 1) {
            setEntrancesData([]);
            return
        }

        // setIsLoading(true);
        const url = `${process.env.REACT_APP_BE_DOMAIN}/api/target/getEntrances?buildingId=` + buildingSelectedData[0];

        try {
            const response = await apiAxios.get(url);

            if (response) {
                if (response.status === 200 && response.data) {


                    setEntrancesData(response.data);
                }
            }

            // setIsLoading(false);
        } catch (e) {
            if (e && e.message) {
                //  setServerError(`${t(getServerErrorResourceName({
                //     model: 'subSectionSection',
                //     resultCode: ResultCode.ServerError
                //  }))} Message: (${e.message})`);
            }
            // setIsLoading(false);
        }

    };

    const loadApartments = async () => {

        if(!buildingSelectedData || buildingSelectedData.length !== 1) {
            setEntrancesData([]);
            return
        }

        // setIsLoading(true);
        const url = `${process.env.REACT_APP_BE_DOMAIN}/api/target/getPropertyObjects?buildingId=` + buildingSelectedData[0];

        try {
            const response = await apiAxios.get(url);

            if (response) {
                if (response.status === 200 && response.data) {


                    setApartmentsData(response.data);
                }
            }

            // setIsLoading(false);
        } catch (e) {
            if (e && e.message) {
                //  setServerError(`${t(getServerErrorResourceName({
                //     model: 'subSectionSection',
                //     resultCode: ResultCode.ServerError
                //  }))} Message: (${e.message})`);
            }
            // setIsLoading(false);
        }

    };

    const onSectionInnerChange = (ev) => {
        if (onSectionChange) {
            let values =[];

            if(ev && ev.value) {

                ev.value.forEach(evKey => {

                    values.push({id: evKey, label: sectionsData.find(e => e.id + "" === evKey + "").text})
                })
                setSectionsSelectedData(ev.value)
            }


            onSectionChange(values);
        }
    };
    const onStreetInnerChange = (ev) => {
        if (onStreetChange) {
            let values =[];

            if(ev && ev.value) {

                ev.value.forEach(evKey => {

                    values.push({id: evKey, label: streetsData.find(e => e.id + "" === evKey + "").text})
                })
                setStreetsSelectedData(ev.value)
            }


            onStreetChange(values);
        }
    };
    const onBuildingInnerChange = (ev) => {
        if (onBuildingChange) {
            let values =[];

            if(ev && ev.value) {

                ev.value.forEach(evKey => {

                    values.push({id: evKey, label: buildingsData.find(e => e.id + "" === evKey + "").text})
                })
                setBuildingSelectedData(ev.value)
            }


            onBuildingChange(values);
        }
    };
    const onEntranceInnerChange = (ev) => {
        console.log("onBuildingInnerChange " )
        if (onEntranceChange) {
            let values =[];

            if(ev && ev.value) {
                ev.value.forEach(evKey => {

                    values.push({id: evKey, label: entrancesData.find(e => e.id + "" === evKey + "").text})
                })
                setEntranceSelectedData(ev.value)
            }

            onEntranceChange(values);
        }
    };
    const onApartmentInnerChange = (ev) => {
        if (onApartmentChange) {
            let values =[];
            if(ev && ev.value) {
                ev.value.forEach(evKey => {

                    values.push({id: evKey, label: apartmentsData.find(e => e.id + "" === evKey + "").text})
                })
                setApartmentSelectedData(ev.value)
            }

            onApartmentChange(values);
        }
    };

    function onStreetFiltering(args) {
        let query = new Query();
        // frame the query based on search string with filter type.
        query = (args.text !== "") ? query.where("text", "contains", args.text, true) : query;
        // pass the filter data source, filter query to updateData method.
        args.updateData(streetsData, query);
    }
    function onSectionFiltering(args) {
        let query = new Query();
        // frame the query based on search string with filter type.
        query = (args.text !== "") ? query.where("text", "contains", args.text, true) : query;
        // pass the filter data source, filter query to updateData method.
        args.updateData(sectionsData, query);
    }
    function onBuildingFiltering(args) {
        let query = new Query();
        // frame the query based on search string with filter type.
        query = (args.text !== "") ? query.where("text", "contains", args.text, true) : query;
        // pass the filter data source, filter query to updateData method.
        args.updateData(buildingsData, query);
    }
    function onEntrancesFiltering(args) {
        let query = new Query();
        // frame the query based on search string with filter type.
        query = (args.text !== "") ? query.where("text", "contains", args.text, true) : query;
        // pass the filter data source, filter query to updateData method.
        args.updateData(entrancesData, query);
    }
    function onApartmentsFiltering(args) {
        let query = new Query();
        // frame the query based on search string with filter type.
        query = (args.text !== "") ? query.where("text", "contains", args.text, true) : query;
        // pass the filter data source, filter query to updateData method.
        args.updateData(apartmentsData, query);
    }

    const {t} = useTranslation();
    const buildingTypes = [
        {id: 0, text: t('locationTarget.cottage')},
        {id: 1, text: t('locationTarget.multi-storey')}
    ];

   /* useEffect(() => {
        if (sectionValue) {
            if (streetQuery && streetQuery.params.length > 0) {
                if (streetQuery.params.find(item => item.key === 'sectionId' && item.value !== sectionValue)) {
                    setStreetQuery(new Query().addParams("sectionId", sectionValue));
                }
            } else {
                setStreetQuery(new Query().addParams("sectionId", sectionValue));
            }
        }
    }, [sectionValue]);*/

    useEffect(() => {
        (async () => await loadBuildings())();
    }, [streetsSelectedData]);

    useEffect(() => {
        (async () => await loadStreets())();
    }, [sectionsSelectedData]);
    useEffect(() => {
        (async () => await loadSections())();
    }, []);
    useEffect(() => {
        if (buildingSelectedData && buildingSelectedData.length > 0) {
            /*if (entranceQuery && entranceQuery.params.length > 0) {
                if (entranceQuery.params.find(item => item.key === 'buildingId' && item.value !== buildingNumberValue)) {
                    setEntranceQuery(new Query().addParams("buildingId", buildingNumberValue));
                }
            } else {
                setEntranceQuery(new Query().addParams("buildingId", buildingNumberValue));
            }
            if (apartmentQuery && apartmentQuery.params.length > 0) {
                if (apartmentQuery.params.find(item => item.key === 'buildingId' && item.value !== buildingNumberValue)) {
                    setApartmentQuery(new Query().addParams("buildingId", buildingNumberValue));
                }
            } else {
                setApartmentQuery(new Query().addParams("buildingId", buildingNumberValue));
            }*/
            (async () => await loadEntrances())();
            (async () => await loadApartments())();
        } else {
            onEntranceInnerChange(null);
            onApartmentInnerChange(null);
            setEntranceSelectedData([])
            setApartmentSelectedData([])
        }
    }, [buildingSelectedData]);

   /* const onChange = useCallback((ev) => {
        if (onSectionChange) {
            if (!ev.itemData) {
                onBuildingTypeChange(null);
                onStreetChange(null);
                onBuildingInnerChange(null);
                onEntranceInnerChange(null);
                onApartmentInnerChange(null);
            }
            onSectionChange(ev);
        }
    }, []);*/

    const onTypeChange = useCallback((ev) => {
        if (onBuildingTypeChange) {
            onBuildingTypeChange(ev);
        }
    }, []);

   /* const onStreetValueChange = useCallback((ev) => {
        if (onStreetChange) {
            if (!ev.itemData) {
                onBuildingChange(null);
            }
            onStreetChange(ev);
        }
    }, []);*/


    return (
        <div className='target-form-container'>
            <div className='input-container syncfusion-control-input-container'>
                <label className='label required'>
                    {t("locationTarget.section")}
                </label>
                <MultiSelectComponent filtering={onSectionFiltering} allowFiltering={true}
                                      popupHeight='250px'
                                      change={onSectionInnerChange}
                                      enabled={!isLoading}
                                      placeholder={t("locationTarget.undefined")}
                                      fields={section_fields}
                                      value={sectionsSelectedData}
                                      dataSource={sectionsData} mode="CheckBox"
                                      showClearButton={true}> <Inject services={[CheckBoxSelection]}/></MultiSelectComponent>


            </div>
            <div className='target-form-container'>

                    <Input name={'sectionParking'} type={"checkbox"} checked={parking} disabled={isLoading}  onChange={onParkingChange} />
                    <label style={{marginLeft:'5px',verticalAlign: 'top'}} className='label'>
                        {t("locationTarget.parking")}
                    </label>

            </div>
            <div className='input-container syncfusion-control-input-container'>
                <label className='label'>
                    {t("locationTarget.building-type")}
                </label>
                <DropDownListComponent dataSource={buildingTypes}
                                       placeholder={t("locationTarget.undefined")}
                                       popupHeight='250px'
                                       fields={{text: 'text', value: 'id'}}
                                       change={onTypeChange}
                                       enabled={sectionsSelectedData && sectionsSelectedData.length > 0}
                                       value={buildingTypeValue}
                                       showClearButton={true}/>

            </div>
            <div className='input-container syncfusion-control-input-container'>
                <label className='label'>
                    {t("locationTarget.street")}
                </label>
                <MultiSelectComponent filtering={onStreetFiltering} allowFiltering={true}
                                      popupHeight='250px'
                                      change={onStreetInnerChange}
                                      enabled={sectionsSelectedData && sectionsSelectedData.length === 1}
                                      placeholder={t("locationTarget.undefined")}
                                      fields={street_fields}
                                      value={streetsSelectedData}
                                      dataSource={streetsData} mode="CheckBox"
                                      showClearButton={true}> <Inject services={[CheckBoxSelection]}/></MultiSelectComponent>

            </div>
            <div className='input-container syncfusion-control-input-container'>
                <label className='label'>
                    {t("locationTarget.home-number")}
                </label>
                <MultiSelectComponent filtering={onBuildingFiltering} allowFiltering={true}
                                      popupHeight='250px'
                                      change={onBuildingInnerChange}
                                      enabled={streetsSelectedData && streetsSelectedData.length === 1}
                                      placeholder={t("locationTarget.undefined")}
                                      fields={building_fields}
                                      value={buildingSelectedData}
                                      dataSource={buildingsData} mode="CheckBox"
                                      showClearButton={true}> <Inject services={[CheckBoxSelection]}/></MultiSelectComponent>
            </div>
            <div className='input-container syncfusion-control-input-container'>
                <label className='label'>
                    {t("locationTarget.entrance-number")}
                </label>
                <MultiSelectComponent filtering={onEntrancesFiltering} allowFiltering={true}
                                      popupHeight='250px'
                                      change={onEntranceInnerChange}
                                      enabled={buildingSelectedData && buildingSelectedData.length === 1}
                                      placeholder={t("locationTarget.undefined")}
                                      fields={entrance_fields}
                                      value={entranceSelectedData}
                                      dataSource={entrancesData} mode="CheckBox"
                    //  value={value}
                                      showClearButton={true}> <Inject services={[CheckBoxSelection]}/></MultiSelectComponent>
            </div>
            <div className='input-container syncfusion-control-input-container'>
                <label className='label'>
                    {t("locationTarget.apartment-number")}
                </label>
                <MultiSelectComponent filtering={onApartmentsFiltering} allowFiltering={true}
                                      popupHeight='250px'
                                      change={onApartmentInnerChange}
                                      enabled={buildingSelectedData && buildingSelectedData.length === 1}
                                      placeholder={t("locationTarget.undefined")}
                                      fields={apartment_fields}
                                      value={apartmentSelectedData}
                                      dataSource={apartmentsData} mode="CheckBox"
                    //  value={value}
                                      showClearButton={true}> <Inject services={[CheckBoxSelection]}/></MultiSelectComponent>
            </div>
        </div>
    );
};

export default SectionSection;
